<script>
    import {Card, Button, Icon} from 'svelte-chota';
    import {mdiChevronRight} from '@mdi/js';

    export let profile;
    export let app;
    export let roles;
</script>

<style>
    .app-label {
        margin-left: 8px;
    }

    .app-header {
        margin: 0;
    }

    .service-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
    }
</style>

<Card class="text-dark">
    <h4 slot="header" class="app-header is-vertical-align">
        <Icon src={app.icon} size="28px"/>
        <span class="app-label">{app.name}</span>
    </h4>
    {#if app.client === "account"}
        {#if profile && profile.username}
            Username: {profile.username}<br>
        {/if}
        {#if profile && profile.email}
            Email: {profile.email}<br>
        {/if}
        {#if profile && (profile.firstName || profile.lastName)}
            Name: {[profile.firstName, profile.lastName].filter((e) => !!e).join(' ')}<br>
        {/if}
    {/if}
    {#if roles.length > 0}
        Granted roles:
        <ul>
            {#each roles as role}
                <li class="text-lowercase">{role}</li>
            {/each}
        </ul>
    {/if}
    {#if app.url || app.argo_deployment}
        <footer class="service-footer">
            {#if app.argo_deployment}
                <img src="https://argocd.aur.rocks/api/badge?name={app.argo_deployment}" alt="service badge" width="160" height="24"/>
            {/if}
            {#if app.url}
                <a href={app.url} target="_blank">
                    <Button primary outline iconRight={mdiChevronRight}>GO</Button>
                </a>
            {/if}
        </footer>
    {/if}
</Card>
